// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"528":"Sudoku","798":"Footer"}[chunkId] || chunkId) + "." + {"80":"41fb3dd9","528":"fa8ee4fd","798":"92112c5d","838":"df1abf28"}[chunkId] + ".chunk.css";
};